import linkProcess from '../link/process';
export async function formationNext(cache, current, redirect, context, options) {
    const {
        id,
        context: updated,
        redirect: redirection
    } = await linkProcess(current.link, redirect, context, options);
    const fetched = await cache.fetch(id);
    return {
        formation: fetched,
        redirect: redirection,
        context: updated
    };
}
export {
    formationNext as next
};
export default formationNext;    //# sourceMappingURL=next.js.map
